import { DOMAIN_NAME } from './config';

export const PROJECTS = 'projects';
export const PROJECT = 'project';
export const SETTINGS = 'settings';
export const USERS = 'users';
export const PROFILE = 'profile';
export const ONBOARDING = 'start';
export const CREATE_WORKSPACE = `${ONBOARDING}/workspace`;
export const UNAUTHORIZED_WORKSPACE_ACCESS = 'unauthorized';
export const WORKSPACE_INVITE_LOGIN = 'invite';

export const WORKSPACE_URL_REGEX = `^(?!login)[a-z0-9]+.${DOMAIN_NAME}`;
